import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M48 0v-186h864V0H48Zm152-286 210-586h140l211 586H633l-43-136H376l-46 136H200Zm212-244h138l-68-212h-4l-66 212Z" }, null, -1)
  ]))]))
}
export default { render: render }